/**
 * Get baseurl of app "https://orton.fi"
 */
export const getAppBaseUrl = () => {
  return window.location.origin;
};

/**
 * Get baseurl of website "https://orton.fi"
 */
export const getWebsiteBaseUrl = () => {
  if (window.location.host.includes('localhost')) {
    return 'https://orton.local';
  } else {
    return window.location.origin;
  }
};

/**
 * Is local development site
 */
export const isLocalDevelopmentSite = () => {
  if (getWebsiteBaseUrl().includes('.local')) {
    return true;
  }
  return false;
};

/**
 * Retrun GET variables from APP url
 */
export const getAppQueryParam = (name) => {

  const url = window.location.href;
  name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
  const regexS = "[\\?&]"+name+"=([^&#]*)";
  const regex = new RegExp(regexS);
  const results = regex.exec(url);
  return results == null ? null : results[1];

};

/**
 * Get lang param
 */
export const getLang = () => {

  let locale = getAppQueryParam('lang');
  if (locale === null) {
    locale = 'fi';
  }
  return locale;

};

/**
 * Get url of website API
 */
export const getWebsiteApiUrl = () => {

  return getWebsiteBaseUrl() + '?orton-api' + '&lang=' + getLang();

};

/**
 * Save and validate axios response from website api
 *
 * @return bool isValid
 */

export const saveAndValidateWebsiteApiResponse = (response) => {

  if (response.status !== 200) {
    console.error('Website API responds with non-200 status', response);
    return false;
  }

  if (response.headers["content-type"] !== "application/json") {
    console.error('Website API responds with wrong content-type', response);
    return false;
  }

  if (response.data.length === 0) {
    console.error('Website API responds with empty string', response);
    return false;
  }

  if (response.data.i18n.strings.length === 0) {
    console.error('Website API responds with empty localization strings', response);
    return false;
  }

  // announce envirornment
  const env = (response.data.env.booking.is_production) ? '👩‍⚕️👩‍⚕️👩‍⚕️ BOOKING ENV: PROD 👩‍⚕️👩‍⚕️👩‍⚕️' : '👷‍♂️👷‍♂️👷‍♂️ BOOKING ENV: DEV 👷‍♂️👷‍♂️👷‍♂️';
  console.log(env);

  console.log('Fetch i18n:', response.request.responseURL, response.data);

  // save until refresh
  window.ortonWebsiteData = response.data;
  return true;

};

/**
 * Scroll website to top of app
 *
 * Send message via postMessage API
 */
export const scrollWebsiteToAppStart = () => {

  window.parent.postMessage('scroll', document.location.href);

};
